import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
export default {
  name: "Mine",
  components: {},
  props: [],
  data: function data() {
    return {
      routerList: [{
        label: "个人信息",
        icon: "myfont icon-zhanghao",
        path: "/mine/userData"
      }, {
        label: "我的事务",
        icon: "myfont icon-zuhe",
        path: "/mine/myAffair"
      }, {
        label: "消息中心",
        icon: "el-icon-chat-dot-round ",
        path: "/mine/message"
      }, {
        label: "我的收藏",
        icon: "el-icon-shopping-bag-1",
        path: "/mine/collect"
      }, {
        label: "我的留言",
        icon: "myfont icon-youxiang",
        path: "/mine/voiceMessage"
      }, // {
      //   label: "自定义服务",
      //   icon: "myfont icon-zuhe",
      //   path: "/mine/customized"
      // },
      {
        label: "我的建议",
        icon: "myfont icon-liuyan",
        path: "/mine/suggest"
      }, {
        label: "账号安全",
        icon: "myfont icon-zhanghaomima",
        path: "/mine/passwordEdit"
      } // {
      //   label: "日程信息",
      //   icon: "myfont icon-rili",
      //   path: "/mine/schedule"
      // }
      ]
    };
  },
  computed: _objectSpread({}, mapGetters(["userData"])),
  created: function created() {
    this.addViewRouter();
  },
  mounted: function mounted() {// console.log(this.$route.path)
    // this.$router.push(this.routerList[0].path)
  },
  destroyed: function destroyed() {},
  methods: {
    linkView: function linkView(item) {
      this.$router.push({
        path: item.path
      });
    },
    addViewRouter: function addViewRouter() {
      var _this = this;

      this.routerList = this.routerList.filter(function (val) {
        return _this.userData.routerData.indexOf(val.path) > -1;
      });
    }
  },
  watch: {},
  filters: {}
};